import type { DrillDownNode } from './types';

// Example meta type for UI/data (can be extended by consumer)
export interface DDNodeMeta {
  label: string;
  component?: React.ComponentType<{ params: Record<string, string> }>;
}

export const drillDownTree: DrillDownNode<DDNodeMeta>[] = [
  {
    segment: 'projects',
    label: 'Projects',
    component: undefined,
    children: [
      {
        segment: ':projectId/:?tab',
        label: 'Project Details',
        component: undefined,
        children: [
          {
            prefix: 'tickets',
            segment: ':ticketId',
            label: 'Ticket Details',
            component: undefined,
          },
          {
            prefix: 'docs',
            segment: ':groupOrFileId',
            label: 'Docs',
            component: undefined,
          },
          {
            prefix: 'works',
            segment: ':workId/:?tab',
            label: 'Work Details',
            component: undefined,
            children: [
              {
                prefix: 'tickets',
                segment: ':ticketId',
                label: 'Ticket Details',
                component: undefined,
              },
              {
                prefix: 'lists',
                segment: ':checklistId/:?questionId',
                label: 'List Details',
                component: undefined,
              },
            ],
          },
        ],
      },
    ],
  },
  // Overview with two optional params drilling into a literal child segment
  // (mirrors /day-planning in the app routes).
  {
    segment: 'day-planning/:?date/:?techId',
    label: 'Day Planning',
    component: undefined,
    children: [
      {
        segment: 'workorders/:workorderId/:?tab',
        label: 'Workorder Details',
        component: undefined,
      },
    ],
  },
  // Overview with an optional leading param that drills down into a subtree
  // via a literal child segment (mirrors /my-workorders in the app routes).
  {
    segment: 'my-workorders/:?date',
    label: 'My Workorders',
    component: undefined,
    children: [
      {
        segment: 'workorders/:workorderId/sign',
        label: 'Sign & Complete',
        component: undefined,
      },
      {
        segment: 'workorders/:workorderId/:?tab',
        label: 'Workorder Details',
        component: undefined,
        children: [
          {
            prefix: 'labor',
            segment: ':laborId',
            label: 'Labor Entry',
            component: undefined,
          },
        ],
      },
    ],
  },
];
